<template>
  <div class="box">
    <!-- 通栏底部 -->
    <div class="bottom_text">
      <div class="top">
        <div>杭州安略网络技术有限公司 版权所有</div>
        <div> 地址：浙江省杭州市滨江区西兴街道江淑路260号13656室</div>
        <!-- <div>aaaaaaaaaaaaaaaa增值电信业务经营许可证：浙B2-20220337</div> -->
      </div>
      <div class="bottom">
        网站备案：浙ICP备2025208385号
      </div>
      <!-- <div class="left">杭州安略网络技术有限公司&nbsp;&nbsp;版权所有</div>
      <div class="right">
        <div>地址：浙江省杭州市滨江区西兴街道江淑路260号13656室</div>
        <div>aaaaaaaaaaaaaaaa增值电信业务经营许可证：浙B2-20220337</div>
        <div>网站备案：浙ICP备2025208385号</div>
      </div> -->
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
// @media (min-width: 992px) {

  // 通栏底部
  .box {
    height: 250px;
    background-color: #21305d;
    padding-top: 30px;
      position: relative;
      color: #ffffff;
    .bottom_text {
      display: flex;
      flex-direction: column;
     .top{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 122px;
      font-size: 17px;
      div{
        margin-top: 17px;
      }
     }
     .bottom{
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 75px;
      background-color: rgba(0,0,0,0.5);
      font-size: 17px;
      text-align: center;
      line-height: 75px;
     }
    }

    
  }
// }

@media (max-width: 750px) {}
</style>
